class SubscriptionPlanSelector extends HTMLElement {
	constructor() {
		super();
		this.select = this.querySelector('select');
		this.select.addEventListener('change', this.onPlanChange.bind(this));
	}

	onPlanChange(event) {
		event.stopPropagation();
		const itemKey = this.dataset.itemKey;
		const lineIndex = parseInt(this.dataset.lineIndex);
		const newPlanId = parseInt(this.select.value);

		const cartContainer =
			this.closest('cart-drawer-items') || this.closest('cart-items');

		if (!cartContainer) return;

		cartContainer.enableLoading(lineIndex);

		if (newPlanId === 0) {
			this.convertToOneTime(itemKey, lineIndex, cartContainer);
		} else {
			this.changePlan(itemKey, lineIndex, newPlanId, cartContainer);
		}
	}

	convertToOneTime(itemKey, lineIndex, cartContainer) {
		const cartItemEl =
			document.getElementById(`CartDrawer-Item-${lineIndex}`) ||
			document.getElementById(`CartItem-${lineIndex}`);

		if (!cartItemEl) {
			this.disableLoadingFresh(lineIndex);
			return;
		}

		const variantId = parseInt(cartItemEl.dataset.variantId);
		const quantityInput =
			document.getElementById(`Quantity-${lineIndex}`) ||
			cartItemEl.querySelector('.quantity__input');
		const currentQuantity = parseInt(quantityInput?.value) || 1;

		// Step 1: remove the subscription line item
		fetch(routes.cart_change_url, {
			...fetchConfig(),
			body: JSON.stringify({ id: itemKey, quantity: 0 }),
		})
			.then((r) => r.json())
			.then((removeState) => {
				if (removeState.status >= 400) {
					throw new Error(removeState.description || removeState.message);
				}
				// Step 2: re-add the variant without a selling plan
				return fetch(routes.cart_add_url, {
					...fetchConfig(),
					body: JSON.stringify({ id: variantId, quantity: currentQuantity }),
				});
			})
			.then((r) => r.json())
			.then((addState) => {
				if (addState.status >= 400) {
					throw new Error(addState.description || addState.message);
				}
				// Step 3: fetch sections via GET — more reliable than relying on
				// /cart/add.js to return correctly formatted section HTML
				const sectionIds = cartContainer
					.getSectionsToRender()
					.map((s) => s.section)
					.join(',');
				return fetch(`${routes.cart_url}?sections=${sectionIds}`);
			})
			.then((r) => r.json())
			.then((sections) => {
				// GET /cart?sections=... returns { 'section-id': '<html>' } directly
				this.renderSections({ sections }, cartContainer);
			})
			.catch((e) => {
				console.error('One-time purchase conversion failed:', e);
			})
			.finally(() => {
				this.disableLoadingFresh(lineIndex);
			});
	}

	disableLoadingFresh(lineIndex) {
		const fc =
			document.querySelector('cart-drawer-items') ||
			document.querySelector('cart-items');
		if (fc) fc.disableLoading(lineIndex);
	}

	changePlan(itemKey, lineIndex, newPlanId, cartContainer) {
		fetch(routes.cart_change_url, {
			...fetchConfig(),
			body: JSON.stringify({
				id: itemKey,
				selling_plan: newPlanId,
				sections: cartContainer.getSectionsToRender().map((s) => s.section),
				sections_url: window.location.pathname,
			}),
		})
			.then((r) => r.json())
			.then((parsedState) => {
				if (parsedState.errors) {
					console.error('Subscription plan change error:', parsedState.errors);
					return;
				}
				this.renderSections(parsedState, cartContainer);
			})
			.catch((e) => {
				console.error('Subscription plan change failed:', e);
			})
			.finally(() => {
				const fc =
					document.querySelector('cart-drawer-items') ||
					document.querySelector('cart-items');
				if (fc) fc.disableLoading(lineIndex);
			});
	}

	renderSections(parsedState, cartContainer) {
		cartContainer.getSectionsToRender().forEach((section) => {
			const elementToReplace =
				document.getElementById(section.id)?.querySelector(section.selector) ||
				document.getElementById(section.id);

			if (elementToReplace) {
				elementToReplace.innerHTML = cartContainer.getSectionInnerHTML(
					parsedState.sections[section.section],
					section.selector
				);
			}
		});

		if (document.querySelector('.cart-shipping') && typeof cartContainer.cartShipping === 'function') {
			cartContainer.cartShipping();
		}

		publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
	}
}

customElements.define('subscription-plan-selector', SubscriptionPlanSelector);
